import React, { useEffect, useState } from 'react';
import { collection, doc, getDoc, getDocs, query } from 'firebase/firestore';
import Table from 'react-bootstrap/Table';
import { Link, useNavigate } from 'react-router-dom';
import { db } from '../firebase.js';
import { formatDate } from '../common/formatDate.js';
import { describeGame } from '../common/describeGame.js';
import { compareGames } from '../common/compareGames.js';
import GameTypeBadge from './GameTypeBadge.js';

function winPct(player) {
  const total = player.wins + player.losses + player.ties;
  if (total === 0) return 0;
  return (player.wins + 0.5 * player.ties) / total;
}

export default function Home() {
  const navigate = useNavigate();
  const [players, setPlayers] = useState(null);
  const [recentGames, setRecentGames] = useState(null);

  useEffect(() => {
    getDoc(doc(db, 'homepage', 'standings')).then(snap => {
      const data = snap.exists() ? snap.data().players ?? {} : {};
      const rows = Object.entries(data).map(([id, p]) => ({ id, ...p }));
      rows.sort((a, b) => winPct(b) - winPct(a));
      setPlayers(rows);
    });

    getDocs(query(collection(db, 'games'))).then(snap => {
      const all = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      all.sort(compareGames);
      setRecentGames(all.slice(0, 3));
    });
  }, []);

  if (players === null || recentGames === null) return <p>Loading…</p>;

  const nameFor = id => players.find(p => p.id === id)?.name ?? '';

  return (
    <div className="w-100">
      <div className="d-flex justify-content-end mb-3" style={{ gap: '0.75rem' }}>
        <Link to="/games/new" className="pill-button">+ Add Game</Link>
      </div>

      {recentGames.length > 0 && (
        <div className="panel mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="section-title mb-0">Recent Games</h2>
            <Link to="/games">View all</Link>
          </div>
          {recentGames.map(g => (
            <div
              key={g.id}
              className="recent-game-row"
              onClick={() => navigate(`/games/${g.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <span>{describeGame(g, nameFor)}</span>
              <span className="text-muted recent-game-date d-flex align-items-center" style={{ gap: '0.5rem' }}>
                {formatDate(g.datePlayed)}
                <GameTypeBadge type={g.type} />
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="panel">
        <h2 className="section-title mb-3">Standings</h2>
        <Table striped bordered hover className="mb-0">
          <thead>
            <tr>
              <th>Player</th>
              <th>Win</th>
              <th>Loss</th>
              <th>Tie</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {players.map(p => (
              <tr key={p.id} onClick={() => navigate(`/players/${p.id}`)} style={{ cursor: 'pointer' }}>
                <td>{p.name}</td>
                <td>{p.wins}</td>
                <td>{p.losses}</td>
                <td>{p.ties}</td>
                <td>{(winPct(p) * 100).toFixed(1)}%</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
